import { TFunction } from 'react-i18next';

export const buildTransferFilterTooltip = (t: TFunction) =>
    t('TRANS-transfer-tooltip-included');

export const buildRailAndFlyFilterTooltip = (t: TFunction) =>
    t('TRANS-transfer-tooltip-railandfly');

export const buildDirectFlightFilterTooltip = (t: TFunction) => t('TRANS'); //TODO: define translation

export const buildWithNoBagFilterTooltip = (t: TFunction) =>
    t('TRANS-flights-with-hand-luggage-only');
